/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Needs_InstallInputs */

const th_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่ม Remy ไปยังหน้าจอโฮมก่อน — iPhone และ iPad อนุญาตการแจ้งเตือนเฉพาะแอปที่ติดตั้งแล้ว`)
};

const en_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Remy to your Home Screen first — iPhone and iPad only allow notifications for installed apps.`)
};

const ja_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先に Remy をホーム画面に追加してください — iPhone と iPad はインストール済みアプリのみ通知できます。`)
};

const zh_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先把 Remy 添加到主屏幕——iPhone 和 iPad 只允许已安装的应用发送通知。`)
};

const es_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade primero Remy a tu pantalla de inicio: el iPhone y el iPad solo permiten notificaciones en aplicaciones instaladas.`)
};

const pt_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione o Remy à sua Tela de Início primeiro — iPhone e iPad só permitem notificações em aplicativos instalados.`)
};

const id_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan dulu Remy ke Layar Utama — iPhone dan iPad hanya mengizinkan notifikasi untuk aplikasi yang terpasang.`)
};

const fr_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez d’abord Remy à votre écran d’accueil — l’iPhone et l’iPad n’autorisent les notifications que pour les applications installées.`)
};

const tl_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idagdag muna ang Remy sa Home Screen mo — sa mga naka-install na app lamang pinapayagan ng iPhone at iPad ang mga notipikasyon.`)
};

const vi_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hãy thêm Remy vào màn hình chính trước — iPhone và iPad chỉ cho phép thông báo với ứng dụng đã cài.`)
};

const ko_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`먼저 Remy를 홈 화면에 추가하세요. iPhone과 iPad는 설치된 앱에만 알림을 허용합니다.`)
};

const de_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge Remy zuerst zu deinem Home-Bildschirm hinzu — iPhone und iPad erlauben Benachrichtigungen nur für installierte Apps.`)
};

const ru_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сначала добавьте Remy на экран «Домой» — iPhone и iPad разрешают уведомления только установленным приложениям.`)
};

const tr_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önce Remy'yi Ana Ekranınıza ekleyin — iPhone ve iPad yalnızca yüklü uygulamalara bildirim izni verir.`)
};

const it_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi prima Remy alla schermata Home: iPhone e iPad consentono le notifiche solo alle app installate.`)
};

const pl_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najpierw dodaj Remy do ekranu początkowego — iPhone i iPad pozwalają na powiadomienia tylko zainstalowanym aplikacjom.`)
};

const uk_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спершу додайте Remy на екран «Домівка» — iPhone та iPad дозволяють сповіщення лише встановленим застосункам.`)
};

const hi_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले Remy को अपनी होम स्क्रीन में जोड़ें — iPhone और iPad केवल इंस्टॉल किए ऐप को सूचनाएँ देने देते हैं।`)
};

const ar_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أضف Remy إلى شاشتك الرئيسية أولًا — لا يسمح iPhone وiPad بالإشعارات إلا للتطبيقات المثبَّتة.`)
};

const ms_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah Remy ke Skrin Utama anda dahulu — iPhone dan iPad hanya membenarkan pemberitahuan untuk aplikasi yang dipasang.`)
};

const bn_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আগে Remy-কে হোম স্ক্রিনে যোগ করুন — iPhone ও iPad কেবল ইনস্টল করা অ্যাপকে বিজ্ঞপ্তির অনুমতি দেয়।`)
};

const zh_tw2_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請先將 Remy 加入主畫面——iPhone 與 iPad 只允許已安裝的應用程式發送通知。`)
};

const zh_hk2_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請先將 Remy 加入主畫面——iPhone 與 iPad 只允許已安裝的應用程式發送通知。`)
};

const ur_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پہلے Remy کو ہوم اسکرین میں شامل کریں — iPhone اور iPad صرف انسٹال شدہ ایپ کو اطلاعات کی اجازت دیتے ہیں۔`)
};

const fa_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نخست Remy را به صفحهٔ خانه بیفزایید — iPhone و iPad تنها به برنامه‌های نصب‌شده اجازهٔ اعلان می‌دهند.`)
};

const sw_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeza Remy kwenye Skrini yako ya Mwanzo kwanza — iPhone na iPad huruhusu arifa kwa programu zilizosakinishwa pekee.`)
};

const nl_push_needs_install = /** @type {(inputs: Push_Needs_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet Remy eerst op je beginscherm — iPhone en iPad staan meldingen alleen toe voor geïnstalleerde apps.`)
};

/**
* | output |
* | --- |
* | "Add Remy to your Home Screen first — iPhone and iPad only allow notifications for installed apps." |
*
* @param {Push_Needs_InstallInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_needs_install = /** @type {((inputs?: Push_Needs_InstallInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Needs_InstallInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_needs_install(inputs)
	if (locale === "ja") return ja_push_needs_install(inputs)
	if (locale === "zh") return zh_push_needs_install(inputs)
	if (locale === "es") return es_push_needs_install(inputs)
	if (locale === "pt") return pt_push_needs_install(inputs)
	if (locale === "id") return id_push_needs_install(inputs)
	if (locale === "fr") return fr_push_needs_install(inputs)
	if (locale === "tl") return tl_push_needs_install(inputs)
	if (locale === "vi") return vi_push_needs_install(inputs)
	if (locale === "ko") return ko_push_needs_install(inputs)
	if (locale === "de") return de_push_needs_install(inputs)
	if (locale === "ru") return ru_push_needs_install(inputs)
	if (locale === "tr") return tr_push_needs_install(inputs)
	if (locale === "it") return it_push_needs_install(inputs)
	if (locale === "pl") return pl_push_needs_install(inputs)
	if (locale === "uk") return uk_push_needs_install(inputs)
	if (locale === "hi") return hi_push_needs_install(inputs)
	if (locale === "ar") return ar_push_needs_install(inputs)
	if (locale === "ms") return ms_push_needs_install(inputs)
	if (locale === "bn") return bn_push_needs_install(inputs)
	if (locale === "zh-TW") return zh_tw2_push_needs_install(inputs)
	if (locale === "zh-HK") return zh_hk2_push_needs_install(inputs)
	if (locale === "ur") return ur_push_needs_install(inputs)
	if (locale === "fa") return fa_push_needs_install(inputs)
	if (locale === "sw") return sw_push_needs_install(inputs)
	if (locale === "nl") return nl_push_needs_install(inputs)
	return en_push_needs_install(inputs)
});